function Copyright({socials}) {
    return ( 
        <div className="copyright">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12">
                    <p>تمامی حقوق برای صاحب اثر محفوظ است | ساخته شده با  <i className="fas fa-heart text-danger"></i> در <a href="https://linket.me">لینکت</a></p>
                    </div>
                    <div className="col-lg-6 text-right col-md-12">
                        <div className="social-icons">
                            <ul>
                            {socials && socials.map((row,index) =>
                                {
                                    switch (row.key) {
                                        case 'فیسبوک':
                                            return <li key={index}><a href={row.value}><i className="fab fa-facebook-f"></i></a></li>
                                        case 'توییتر':
                                            return <li key={index}><a href={row.value}><i className="fab fa-twitter"></i></a></li>
                                        case 'اینستاگرام':
                                            return <li key={index}><a href={row.value}><i className="fab fa-instagram"></i></a></li>
                                        case 'یوتیوب':
                                            return <li key={index}><a href={row.value}><i className="fab fa-youtube"></i></a></li>
                                    
                                        default:
                                            return <></>
                                    }
                                }
                            )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Copyright;